import L from 'leaflet'

/******************************************************************/
/**************************** ICONS *******************************/
/******************************************************************/
const base64icon =
  'data:image/png;base64,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'
const base64shadow =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAAC5ElEQVRYw+2YW4/TMBCF45S0S1luXZCABy5CgLQgwf//S4BYBLTdJLax0fFqmB07nnQfEGqkIydpVH85M+NLjPe++dcPc4Q8Qh4hj5D/AaQJx6H/4TMwB0PeBNwU7EGQAmAtsNfAzoZkgIa0ZgLMa4Aj6CxIAsjhjOCoL5z7Glg1JAOkaicgvQBXuncwJAWjksLtBTWZe04CnYRktUGdilALppZBOgHGZcBzL6OClABvMSVIzyBjazOgrvACf1ydC5mguqAVg6RhdkSWQFj2uxfaq/BrIZOLEWgZdALIDvcMcZLD8ZbLC9de4yR1sYMi4G20S4Q/PWeJYxTOZn5zJXANZHIxAd4JWhPIloTJZhzMQduM89WQ3MUVAE/RnhAXpTycqys3NZALOBbB7kFrgLesQl2h45Fcj8L1tTSohUwuxhy8H/Qg6K7gIs+3kkaigQCOcyEXCHN07wyQazhrmIulvKMQAwMcmLNqyCVyMAI+BuxSMeTk3OPikLY2J1uE+VHQk6ANrhds+tNARqBeaGc72cK550FP4WhXmFmcMGhTwAR1ifOe3EvPqIegFmF+C8gVy0OfAaWQPMR7gF1OQKqGoBjq90HPMP01BUjPOqGFksC4emE48tWQAH0YmvOgF3DST6xieJgHAWxPAHMuNhrImIdvoNOKNWIOcE+UXE0pYAnkX6uhWsgVXDxHdTfCmrEEmMB2zMFimLVOtiiajxiGWrbU52EeCdyOwPEQD8LqyPH9Ti2kgYMf4OhSKB7qYILbBv3CuVTJ11Y80oaseiMWOONc/Y7kJYe0xL2f0BaiFTxknHO5HaMGMublKwxFGzYdWsBF174H/QDknhTHmHHN39iWFnkZx8lPyM8WHfYELmlLKtgWNmFNzQcC1b47gJ4hL19i7o65dhH0Negbca8vONZoP7doIeOC9zXm8RjuL0Gf4d4OYaU5ljo3GYiqzrWQHfJxA6ALhDpVKv9qYeZA8eM3EhfPSCmpuD0AAAAASUVORK5CYII='
export const storeIconText = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDYiIGhlaWdodD0iNTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZCkiPjxwYXRoIGQ9Ik0zOCAyMC43MjdDMzggMzIuMTgyIDIzIDQyIDIzIDQyUzggMzIuMTgyIDggMjAuNzI3YzAtMy45MDYgMS41OC03LjY1MiA0LjM5My0xMC40MTRBMTUuMTQyIDE1LjE0MiAwIDAxMjMgNmMzLjk3OCAwIDcuNzk0IDEuNTUyIDEwLjYwNyA0LjMxM0ExNC41OTMgMTQuNTkzIDAgMDEzOCAyMC43Mjd6IiBmaWxsPSIjMkMyRTMwIi8+PHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNi41MjMgMTUuNzI3SDMyLjI1OGEuNjg3LjY4NyAwIDExMCAxLjM3NUgzMC43OHYxMS44NDRhMS4zMyAxLjMzIDAgMDEtMS4zMjkgMS4zM0gxNi41NDhhMS4zMyAxLjMzIDAgMDEtMS4zMy0xLjMzVjE3LjEwMmgtMS40NzZhLjY4Ny42ODcgMCAxMTAtMS4zNzVoMi43ODF6bS4wNyAxLjM3NVYyOC45aDEuMTZ2LTguMTU4YzAtLjUzMS40My0uOTYyLjk2Mi0uOTYyaDguNTdjLjUzMSAwIC45NjIuNDMuOTYyLjk2MlYyOC45aDEuMTU4VjE3LjEwMkgxNi41OTN6bTIuNTM0IDQuMDUzdjEuNjY1aDcuNzQ1di0xLjY2NWgtNy43NDV6bTAgNC43MDV2LTEuNjY1aDcuNzQ1djEuNjY1aC03Ljc0NXptMCAxLjM3NVYyOC45aDcuNzQ1di0xLjY2NWgtNy43NDV6IiBmaWxsPSIjZmZmIi8+PC9nPjxkZWZzPjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZCIgeD0iMCIgeT0iMCIgd2lkdGg9IjQ2IiBoZWlnaHQ9IjUyIiBmaWx0ZXJVbml0cz0idXNlclNwYWNlT25Vc2UiIGNvbG9yLWludGVycG9sYXRpb24tZmlsdGVycz0ic1JHQiI+PGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz48ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiLz48ZmVPZmZzZXQgZHk9IjIiLz48ZmVHYXVzc2lhbkJsdXIgc3RkRGV2aWF0aW9uPSI0Ii8+PGZlQ29sb3JNYXRyaXggdmFsdWVzPSIwIDAgMCAwIDAuMDA4NTc2MzkgMCAwIDAgMCAwLjA2MjgxMzIgMCAwIDAgMCAwLjEwODMzMyAwIDAgMCAwLjUgMCIvPjxmZUJsZW5kIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvdyIvPjxmZUJsZW5kIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvdyIgcmVzdWx0PSJzaGFwZSIvPjwvZmlsdGVyPjwvZGVmcz48L3N2Zz4=`
export const jobIconText = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQuNSAxLjVsLTIuMjUgM1YxNWExLjUwMDEgMS41MDAxIDAgMDAxLjUgMS41aDEwLjVhMS41MDAxIDEuNTAwMSAwIDAwMS41LTEuNVY0LjVsLTIuMjUtM2gtOXpNMi4yNSA0LjVoMTMuNU0xMiA3LjVhMyAzIDAgMDEtNiAwIiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=`
export const truckIconText = `data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEyIDIuMjVILjc1VjEySDEyVjIuMjV6TTEyIDZoM2wyLjI1IDIuMjVWMTJIMTJWNnpNNC4xMjUgMTUuNzVDNS4xNjA1IDE1Ljc1IDYgMTQuOTEwNSA2IDEzLjg3NSA2IDEyLjgzOTUgNS4xNjA1IDEyIDQuMTI1IDEyYy0xLjAzNTUgMC0xLjg3NS44Mzk1LTEuODc1IDEuODc1IDAgMS4wMzU1LjgzOTUgMS44NzUgMS44NzUgMS44NzV6TTEzLjg3NSAxNS43NWMxLjAzNTUgMCAxLjg3NS0uODM5NSAxLjg3NS0xLjg3NSAwLTEuMDM1NS0uODM5NS0xLjg3NS0xLjg3NS0xLjg3NS0xLjAzNTUgMC0xLjg3NS44Mzk1LTEuODc1IDEuODc1IDAgMS4wMzU1LjgzOTUgMS44NzUgMS44NzUgMS44NzV6IiBzdHJva2U9IiNmZmYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=`

export const DefaultMarkerIcon = new L.Icon.Default({
  iconUrl: base64icon,
  shadowUrl: base64shadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
})
/******************************************************************/
/******************************************************************/

export const DEFAULT_MAP_STYLES = [
  {
    featureType: 'poi',
    stylers: [
      {
        saturation: -100
      }
    ]
  },
  {
    featureType: 'poi.attraction',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi.business',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi.government',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi.park',
    stylers: [
      {
        saturation: -5
      }
    ]
  },
  {
    featureType: 'poi.park',
    elementType: 'labels.text',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'poi.place_of_worship',
    elementType: 'labels.icon',
    stylers: [
      {
        lightness: 35
      }
    ]
  },
  {
    featureType: 'poi.sports_complex',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  },
  {
    featureType: 'road.highway',
    stylers: [
      {
        saturation: -5
      },
      {
        visibility: 'simplified'
      }
    ]
  },
  {
    featureType: 'transit.station',
    stylers: [
      {
        visibility: 'off'
      }
    ]
  }
]

export const DEFAULT_CONFIG = {
  zoomControl: false,
  doubleClickZoom: false
}

export const DEFAULT_COLORS = [
  {
    base: '#1890FF',
    mate: '#BADEFF',
    name: 'doger-blue'
  },
  {
    base: '#DE1870',
    mate: '#F6BAD5',
    name: 'red-violet'
  },
  {
    base: '#72B703',
    mate: '#D5EAB4',
    name: 'limeade'
  },
  {
    base: '#F29F05',
    mate: '#FCE3B4',
    name: 'california'
  },
  {
    base: '#A516D8',
    mate: '#E4BAF3',
    name: 'electric-violet'
  },
  {
    base: '#00C08F',
    mate: '#B3EDDE',
    name: 'caribbean-green'
  },
  {
    base: '#F2695C',
    mate: '#FCD2CF',
    name: 'carnation'
  },
  {
    base: '#2E4BF2',
    mate: '#C1C9FC',
    name: 'royal-blue'
  },
  {
    base: '#9280FF',
    mate: '#DFD9FF',
    name: 'heliotrope'
  },
  {
    base: '#AB0E0E',
    mate: '#E6B7B7',
    name: 'tamarillo'
  }
]

export const MAP_JOB_COLORS = {
  CANCELED: { bg: '#D94444', text: '#FFFFFF' },
  CANCELLED: { bg: '#D94444', text: '#FFFFFF' },
  CHECKING_OUT: { bg: '#FFE066', text: '#2C2E30' },
  CHECKOUT: { bg: '#FFE066', text: '#2C2E30' },
  CREATED: { bg: '#ADB5BD', text: '#2C2E30' },
  DELIVERED: { bg: '#2B8A3E', text: '#FFFFFF' },
  DELIVERING: { bg: '#37B24D', text: '#FFFFFF' },
  EXECUTION_DONE: { bg: '#2B8A3E', text: '#FFFFFF' },
  FINISHED: { bg: '#2B8A3E', text: '#FFFFFF' },
  GOING_TO_DESTINATION: { bg: '#3ACF3A', text: '#FFFFFF' },
  GOING_TO_ORIGIN: { bg: '#FFC078', text: '#2C2E30' },
  IN_ROUTE: { bg: '#3ACF3A', text: '#FFFFFF' },
  PICKING: { bg: '#FD7E14', text: '#2C2E30' },
  READY_FOR_PICKUP: { bg: '#66A80F', text: '#FFFFFF' },
  STORED: { bg: '#F59F00', text: '#2C2E30' },
  STORING: { bg: '#F59F00', text: '#2C2E30' },
  TRANSFERRING: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_FROM: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_FROM_PICKING_TO_STORAGE: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_TO: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_TO_STORAGE_FROM_PICKING: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_FROM_STORAGE_TO_DELIVERY: { bg: '#FCC419', text: '#2C2E30' },
  TRANSFERRING_TO_DELIVERY_FROM_STORAGE: { bg: '#FCC419', text: '#2C2E30' },
  PICKING_WITH_PACKING: { bg: '#FAAD14', text: '#2C2E30' },
  PICKING_WITH_UNASSIGNED_ZONE: { bg: '#FF85C0', text: '#2C2E30' },
  PARKED: { bg: '#EB2F96', text: '#2C2E30' },
  AUDITING: { bg: '#FF7A45', text: '#2C2E30' },
  BACK_TO_STORE: { bg: '#FF7A45', text: '#2C2E30' },
  VERIFICATION: { bg: '#FF7A45', text: '#2C2E30' }
}

export const MAP_JOB_RESOURCE_STYLE = {
  dashArray: '10 10',
  color: '#3366FF',
  weight: 4
}
